import { HasKind } from '@/utilities/HasKind';

import { Crumbs } from '../bakery/Crumbs';
import { crumble as crumbleTrackingEvent, TrackingEvent } from '../TrackingEvent';

export const kind = 'AddTrackingEvent';

export interface AddTrackingEvent extends HasKind<typeof kind> {
  trackingEvent: TrackingEvent;
}

export function crumble(action: AddTrackingEvent): Crumbs {
  return {
    event: crumbleTrackingEvent(action.trackingEvent),
  };
}
